/**
 * Token do totem guardado NO DISPOSITIVO (localStorage), por subdomínio — emitido pela gestão (A5, T-54).
 * Não é dado de paciente; identifica só o equipamento.
 */
const key = (sub: string) => `azanas.totem.${sub}`;
export function readTotemToken(sub: string): string | null {
  try { return localStorage.getItem(key(sub)); } catch { return null; }
}
export function saveTotemToken(sub: string, token: string) {
  try { localStorage.setItem(key(sub), token); } catch { /* armazenamento bloqueado */ }
}
export function clearTotemToken(sub: string) {
  try { localStorage.removeItem(key(sub)); } catch { /* ignore */ }
}

/** Inatividade antes de voltar à tela inicial (T-21) — telas de interação. */
export const IDLE_RESET_SECONDS = 120;
/** Tela de saída (T-26) volta sozinha mais rápido. */
export const EXIT_RESET_SECONDS = 60;
export const HEARTBEAT_SECONDS = 60;
